/**
 * Downloads a CSV export from an authenticated endpoint.
 * A plain <a href> can't carry the Authorization Bearer header, so this
 * fetches via authFetch, turns the response into a Blob, and triggers a
 * download through a transient <a download> click.
 */
export async function downloadReportCsv(authFetch, type, from, to) {
  const params = new URLSearchParams();
  if (from) params.append('from', from);
  if (to) params.append('to', to);

  const response = await authFetch(`/api/v1/reports/export/${type}?${params}`);
  if (!response.ok) {
    throw new Error(`Export failed (${response.status})`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${type}-${from || 'all'}-to-${to || 'now'}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
